import React from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import Topbar from "../../components/Topbar/Topbar";
import UserTable from "../../components/UserTable/UserTable";
import { Box } from "@mui/material";

const Users = () => {
  return (
    <Box sx={{ display: "flex" }}>
      <Sidebar collapsed={false} toggleSidebar={() => {}} active="Users" />
      <Box component="main" sx={{ flexGrow: 1, p: 3, mt: 8 }}>
        <Topbar notificationCount={2} />
        <UserTable />
      </Box>
    </Box>
  );
};

export default Users;
